import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type CreateEnvironmentInput = {
  displayName: Scalars['String'];
  environmentType: EnvironmentType;
  name: Scalars['String'];
};

export type CreateEnvironmentResponse = {
  __typename?: 'CreateEnvironmentResponse';
  environment: EnvironmentDetails;
  isSuccess: Scalars['Boolean'];
};

export type EnvironmentDetails = {
  __typename?: 'EnvironmentDetails';
  displayName: Scalars['String'];
  environmentType: EnvironmentType;
  id: Scalars['String'];
  name: Scalars['String'];
};

export enum EnvironmentType {
  NonProduction = 'NonProduction',
  Production = 'Production'
}

export type GetEnvironmentListResponse = {
  __typename?: 'GetEnvironmentListResponse';
  CustomerEnvironment?: Maybe<Array<EnvironmentDetails>>;
  dogFoodEnvironment: EnvironmentDetails;
  sandboxEnvironment: EnvironmentDetails;
};

export type GetEnvironmentsForProductInput = {
  productId: Scalars['String'];
};

export type GetEnvironmentsForProductResponse = {
  __typename?: 'GetEnvironmentsForProductResponse';
  environments?: Maybe<Array<EnvironmentDetails>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createEnvironment: CreateEnvironmentResponse;
};


export type MutationCreateEnvironmentArgs = {
  input: CreateEnvironmentInput;
};

export type Query = {
  __typename?: 'Query';
  getEnvironmentList: GetEnvironmentListResponse;
  getEnvironmentsForProduct: GetEnvironmentsForProductResponse;
};


export type QueryGetEnvironmentsForProductArgs = {
  input: GetEnvironmentsForProductInput;
};

export type GetEnvironmentListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEnvironmentListQuery = { __typename?: 'Query', getEnvironmentList: { __typename?: 'GetEnvironmentListResponse', sandboxEnvironment: { __typename?: 'EnvironmentDetails', id: string, name: string, displayName: string }, CustomerEnvironment?: Array<{ __typename?: 'EnvironmentDetails', id: string, name: string, displayName: string }> | null } };

export type GetEnvironmentsForProductQueryVariables = Exact<{
  input: GetEnvironmentsForProductInput;
}>;


export type GetEnvironmentsForProductQuery = { __typename?: 'Query', getEnvironmentsForProduct: { __typename?: 'GetEnvironmentsForProductResponse', environments?: Array<{ __typename?: 'EnvironmentDetails', id: string, name: string, displayName: string, environmentType: EnvironmentType }> | null } };

export type CreateEnvironmentMutationVariables = Exact<{
  input: CreateEnvironmentInput;
}>;


export type CreateEnvironmentMutation = { __typename?: 'Mutation', createEnvironment: { __typename?: 'CreateEnvironmentResponse', isSuccess: boolean, environment: { __typename?: 'EnvironmentDetails', id: string, name: string, displayName: string } } };


export const GetEnvironmentListDocument = gql`
    query GetEnvironmentList {
  getEnvironmentList {
    sandboxEnvironment {
      id
      name
      displayName
    }
    CustomerEnvironment {
      id
      name
      displayName
    }
  }
}
    `;

/**
 * __useGetEnvironmentListQuery__
 *
 * To run a query within a React component, call `useGetEnvironmentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnvironmentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnvironmentListQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEnvironmentListQuery(baseOptions?: Apollo.QueryHookOptions<GetEnvironmentListQuery, GetEnvironmentListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnvironmentListQuery, GetEnvironmentListQueryVariables>(GetEnvironmentListDocument, options);
      }
export function useGetEnvironmentListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnvironmentListQuery, GetEnvironmentListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnvironmentListQuery, GetEnvironmentListQueryVariables>(GetEnvironmentListDocument, options);
        }
export type GetEnvironmentListQueryHookResult = ReturnType<typeof useGetEnvironmentListQuery>;
export type GetEnvironmentListLazyQueryHookResult = ReturnType<typeof useGetEnvironmentListLazyQuery>;
export type GetEnvironmentListQueryResult = Apollo.QueryResult<GetEnvironmentListQuery, GetEnvironmentListQueryVariables>;
export const GetEnvironmentsForProductDocument = gql`
    query GetEnvironmentsForProduct($input: GetEnvironmentsForProductInput!) {
  getEnvironmentsForProduct(input: $input) {
    environments {
      id
      name
      displayName
      environmentType
    }
  }
}
    `;

/**
 * __useGetEnvironmentsForProductQuery__
 *
 * To run a query within a React component, call `useGetEnvironmentsForProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEnvironmentsForProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEnvironmentsForProductQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetEnvironmentsForProductQuery(baseOptions: Apollo.QueryHookOptions<GetEnvironmentsForProductQuery, GetEnvironmentsForProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEnvironmentsForProductQuery, GetEnvironmentsForProductQueryVariables>(GetEnvironmentsForProductDocument, options);
      }
export function useGetEnvironmentsForProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEnvironmentsForProductQuery, GetEnvironmentsForProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEnvironmentsForProductQuery, GetEnvironmentsForProductQueryVariables>(GetEnvironmentsForProductDocument, options);
        }
export type GetEnvironmentsForProductQueryHookResult = ReturnType<typeof useGetEnvironmentsForProductQuery>;
export type GetEnvironmentsForProductLazyQueryHookResult = ReturnType<typeof useGetEnvironmentsForProductLazyQuery>;
export type GetEnvironmentsForProductQueryResult = Apollo.QueryResult<GetEnvironmentsForProductQuery, GetEnvironmentsForProductQueryVariables>;
export const CreateEnvironmentDocument = gql`
    mutation CreateEnvironment($input: CreateEnvironmentInput!) {
  createEnvironment(input: $input) {
    isSuccess
    environment {
      id
      name
      displayName
    }
  }
}
    `;
export type CreateEnvironmentMutationFn = Apollo.MutationFunction<CreateEnvironmentMutation, CreateEnvironmentMutationVariables>;

/**
 * __useCreateEnvironmentMutation__
 *
 * To run a mutation, you first call `useCreateEnvironmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEnvironmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEnvironmentMutation, { data, loading, error }] = useCreateEnvironmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEnvironmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateEnvironmentMutation, CreateEnvironmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEnvironmentMutation, CreateEnvironmentMutationVariables>(CreateEnvironmentDocument, options);
      }
export type CreateEnvironmentMutationHookResult = ReturnType<typeof useCreateEnvironmentMutation>;
export type CreateEnvironmentMutationResult = Apollo.MutationResult<CreateEnvironmentMutation>;
export type CreateEnvironmentMutationOptions = Apollo.BaseMutationOptions<CreateEnvironmentMutation, CreateEnvironmentMutationVariables>;